import React from 'react';
import { AppRouteProps } from '~/routes';
import Index from './pages/Index';

export default function ResourcesFleetInspectionSurvey(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {
      path: '/survey',
      component: Index,
      isProtected: true,
      permissions: ['inspection_index'],
    }
  ];

  return routes;
}